import React from 'react';
import { Link } from 'gatsby';
import BlockContainer from './BlockContainer';
import { useDirectIntegrations } from '../../utils/useDirectIntegrations';

function IntegrationCard({ integration }) {
  const { title, logo } = integration;

  return (
    <div className="w-[8rem] h-[8rem] p-6 relative">
      <span className="block absolute top-1 left-1 w-full h-full bg-white border-[1px] border-black rounded-xl" />
      <span className="block absolute top-0 left-0 w-full h-full bg-white border-[1px] border-black rounded-xl" />
      <img
        className="max-w-[6rem] max-h-[6rem] mb-0 block absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]"
        src={logo}
        alt={title}
      />
    </div>
  );
}

export default function IntegrationsPromo({
  title,
  description,
  link,
  bgColor,
  textColor,
  padding,
}) {
  const integrations = useDirectIntegrations();

  return (title || description) && integrations?.length > 0 ? (
    <BlockContainer
      title={title}
      description={description}
      bgColor={bgColor}
      textColor={textColor}
      padding={padding}
    >
      <div
        className={`flex flex-wrap justify-center gap-8 max-w-[40rem] mx-auto${
          title || description ? ' mt-10' : ''
        }${link?.link_url && link?.link_text ? ' mb-10' : ''}`}
      >
        {integrations.map((integration, i) => (
          <IntegrationCard key={i} integration={integration} />
        ))}
      </div>
      {link?.link_url && link?.link_text ? (
        <Link to={link.link_url}>{link.link_text} →</Link>
      ) : null}
    </BlockContainer>
  ) : null;
}
